import axios from 'axios'
import session from '@/store/session'

const ApiService = {
    _unauthorizedInterceptorInstalled: false,

    init(baseURL) {
        axios.defaults.baseURL = baseURL;
        axios.defaults.withCredentials = true;
        this.installUnauthorizedInterceptor();
    },

    installUnauthorizedInterceptor() {
        if (this._unauthorizedInterceptorInstalled) {
            return;
        }

        axios.interceptors.response.use(
            (response) => response,
            (error) => {
                const status = error && error.response ? error.response.status : null;

                if (status === 401 && session.isLoggedIn()) {
                    session.clear();

                    if (typeof window !== "undefined") {
                        const nextLocation = "/?login=required";
                        const currentLocation = `${window.location.pathname}${window.location.search}`;

                        if (currentLocation !== nextLocation) {
                            window.location.assign(nextLocation);
                        }
                    }
                }

                return Promise.reject(error);
            }
        );

        this._unauthorizedInterceptorInstalled = true;
    },

    get(resource, config) {
        return axios.get(resource, config)
    },

    post(resource, data, config) {
        return axios.post(resource, data, config)
    },

    put(resource, data, config) {
        return axios.put(resource, data, config)
    },

    patches(resource, data, config) {
        return axios.patch(resource, data, config)
    },

    delete(resource, config) {
        return axios.delete(resource, config)
    },
}

export default ApiService
